// extracted by mini-css-extract-plugin
export default {"CompactCommentInputContainer":"CompactCommentButton-module__CompactCommentInputContainer--mPD5I"};